import MainBlock from './main-block'
export default MainBlock
